/* eslint-disable @typescript-eslint/ban-ts-comment */
import { onError } from '@apollo/client/link/error';
import { serializeError } from 'serialize-error';

export const errorLink = (publishError) => {
  return onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
      const message = graphQLErrors.reduce((prev, cur) => {
        return prev + `Error ${cur.message} ${cur.path}`;
      }, '');

      let trimmedMessage = message.slice(0, 800);
      trimmedMessage = `GraphqlErrors - operationName:${operation.operationName} \b\n` + trimmedMessage;

      if (trimmedMessage.length < message.length) {
        trimmedMessage += '...';
      }
      publishError('GRAPHQL', new Error(trimmedMessage));
    }

    if (networkError) {
      if ('statusCode' in networkError && networkError.statusCode === 401) {
        if (typeof window !== 'undefined') {
          window.location.reload();
        }
      } else {
        publishError(
          'GRAPHQL',
          new Error(
            `Network error - operationName:${operation.operationName} \b\n Error: ${networkError.name} \b\n Message: ${
              networkError.message
              // @ts-ignore
            } \b\n Result: ${JSON.stringify(serializeError(networkError?.result))}`,
          ),
        );
      }
    }
  });
};
